import React from "react";
import "./PrivacyPolicyTwo.scss";

const PrivacyPolicyTwo =() => {
  return (
    <div className="privacy-wrapper">
      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>

        <p className="privacy-intro">
          This App is designed to support safe and transparent school
          transportation by allowing drivers to mark student pick-up and
          drop-off status and notify parents accordingly.
        </p>

        <section>
          <h2>1. Information We Collect</h2>

          <h3>1.1 Driver Information</h3>
          <ul>
            <li>Full name</li>
            <li>Mobile number</li>
            <li>CNIC or identity details (optional, for verification purposes only)</li>
            <li>Vehicle details (van number, route information)</li>
            <li>Login and authentication credentials</li>
          </ul>

          <h3>1.2 Student and Parent Information</h3>
          <ul>
            <li>Student name</li>
            <li>Parent or guardian name</li>
            <li>Parent or guardian contact details</li>
            <li>Pickup and drop-off address or general location</li>
            <li>School name and assigned route details</li>
          </ul>

          <h3>1.3 Trip and Activity Information</h3>
          <ul>
            <li>Pickup confirmation</li>
            <li>Drop-off confirmation</li>
            <li>Date and time of each pickup and drop-off</li>
            <li>Driver activity and trip logs</li>
          </ul>

          <h3>1.4 Device and Technical Information</h3>
          <ul>
            <li>Device type and operating system</li>
            <li>Application usage logs</li>
            <li>IP address (for security and fraud prevention)</li>
          </ul>
        </section>

        <section>
          <h2>2. Purpose of Data Collection</h2>
          <ul>
            <li>Ensure safe and reliable student transportation</li>
            <li>Notify parents or guardians about trip status</li>
            <li>Maintain accurate transportation records</li>
            <li>Improve app functionality and security</li>
            <li>Ensure driver accountability</li>
          </ul>
        </section>

        <section>
          <h2>3. Information Sharing and Disclosure</h2>
          <p>
            We do not sell, rent, or trade personal information. Data may only be
            shared with parents, school authorities, or legal bodies when
            required by law.
          </p>
        </section>

        <section>
          <h2>4. Data Security</h2>
          <p>
            We use reasonable technical and organizational safeguards to protect
            personal information. However, no digital system is 100% secure.
          </p>
        </section>

        <section>
          <h2>5. Location Information</h2>
          <p>
            Location access is used only to verify pickup and drop-off points and
            improve route accuracy. It is not tracked continuously or used for
            marketing.
          </p>
        </section>

        <section>
          <h2>6. Data Retention</h2>
          <p>
            Personal data is retained only as long as necessary to fulfill legal
            or operational requirements. Data deletion can be requested where
            applicable.
          </p>
        </section>

        <section>
          <h2>7. Children’s Privacy</h2>
          <p>
            Children cannot create accounts. Student data is collected solely
            for transportation safety and record-keeping.
          </p>
        </section>

        <section>
          <h2>8. User Rights</h2>
          <ul>
            <li>Access personal information</li>
            <li>Request data correction</li>
            <li>Request data deletion (where legally allowed)</li>
          </ul>
        </section>

        <section>
          <h2>9. Changes to This Privacy Policy</h2>
          <p>
            We may update this policy from time to time. Changes will be
            communicated through the App.
          </p>
        </section>
        <section>
          <h2>10. Van Wala Parent App</h2>
          <p>
* Parents can log in using Google account for quick and secure access.
 <br/>
* Parents can track the trip in real-time through live location updates.
 <br/>
* The app shows how far the driver is from the destination in real-time.
 <br/>
Provides a safe and reliable tracking experience for parents and children.
          </p>
        </section>

        <section className="contact-box">
          <h2>11. Contact Information</h2>
          <p>Email: <strong>vanwaala0@gmail.com</strong></p>
          <p>Phone: <strong>+923390122806</strong></p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicyTwo;
